export default {"src":"/_next/static/media/positionOpposition.f6b2a647.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};